const React = require('react');
const classnames = require('classnames');
const PropTypes = React.PropTypes;
const PureRenderMixin = require('react-addons-pure-render-mixin');

const Loader = React.createClass({
  propTypes: {
    inverse: PropTypes.bool,
  },

  mixins: [PureRenderMixin],

  render() {
    const classes = classnames({
      Loader: true,
      'Loader--inverse': this.props.inverse,
    });

    return (
      <div className={ classes }>
        <span className="Loader-indicator"></span>
        <span className="Loader-indicator"></span>
        <span className="Loader-indicator"></span>
      </div>
    );
  },
});

module.exports = Loader;
